/** Worker Sagas */

import { call, put, takeEvery } from "redux-saga/effects";
import buildHeaders from "../../utils/buildHeaders";
import { actions } from "./index";
import { storeIncluded } from "../dictionarySagas";
import apiClient, { applyHeaders } from "../../utils/apiSwaggerRequest";

/** List Saga
 *  @description: connects to the getUnlockableContent operation
 */
export function* list(action) {
  let headers = yield buildHeaders();
  let {
    projectId,
    pageNum,
    itemNum,
    unlockableContentId,
    eventId,
    votingId,
    partnerDealId,
  } = action.payload;
  try {
    const SwaggerClient = yield call(apiClient);
    let payload;
    if (unlockableContentId) {
      payload = yield call(
        SwaggerClient.apis.UnlockBoundaries
          .listUnlockBoundariesForUnlockableContent,
        {
          project_id: projectId,
          unlockable_content_id: unlockableContentId,
          page: pageNum,
          items: itemNum,
        },
        { requestInterceptor: applyHeaders(headers) }
      );
    } else if (eventId) {
      payload = yield call(
        SwaggerClient.apis.UnlockBoundaries.listUnlockBoundariesForEvent,
        {
          project_id: projectId,
          event_id: eventId,
          page: pageNum,
          items: itemNum,
        },
        { requestInterceptor: applyHeaders(headers) }
      );
    } else if (partnerDealId) {
      payload = yield call(
        SwaggerClient.apis.UnlockBoundaries.listUnlockBoundariesForPartnerDeal,
        {
          project_id: projectId,
          partner_deal_id: partnerDealId,
          page: pageNum,
          items: itemNum,
        },
        { requestInterceptor: applyHeaders(headers) }
      );
    } else if (votingId) {
      payload = yield call(
        SwaggerClient.apis.UnlockBoundaries.listUnlockBoundariesForVoting,
        {
          project_id: projectId,
          voting_id: votingId,
          page: pageNum,
          items: itemNum,
        },
        { requestInterceptor: applyHeaders(headers) }
      );
    } else {
      throw new Error("Unkown Resource");
    }

    if (payload.obj.included)
      yield* storeIncluded({ payload: payload.obj.included });
    yield put({ type: actions.listSuccess, payload: payload });
  } catch (e) {
    yield put({ type: actions.listFail, payload: e });
  }
}

export function* create(action) {
  let headers = yield buildHeaders();
  let {
    project_id,
    title,
    public_description,
    secret_description,
    content_category_id,
    content_type,
    content_status,
  } = action.payload;
  try {
    const SwaggerClient = yield call(apiClient);
    let payload = yield call(
      SwaggerClient.apis.UnlockBoundaries.createUnlockBoundaryForProject,
      { project_id: project_id },
      {
        requestInterceptor: applyHeaders(headers),
        requestBody: {
          title: title,
          public_description: public_description,
          secret_description: secret_description,
          content_type: content_type,
          status: content_status,
          content_category_id: content_category_id,
        },
      }
    );

    if (payload.obj?.included)
      yield* storeIncluded({ payload: payload.obj.included });
    yield put({ type: actions.createSuccess, payload: payload.obj.data });
  } catch (e) {
    yield put({ type: actions.createFail, payload: e });
  }
}
/** Show Saga
 *  @description: connects to the showUnlockableContent operation
 *  @param {number} action.payload the UnlockableContent id
 */
export function* show(action) {
  let headers = yield buildHeaders();
  const { projectId, id } = action.payload;
  try {
    const SwaggerClient = yield call(apiClient);
    const payload = yield call(
      SwaggerClient.apis.UnlockBoundaries.showUnlockBoundaryForProject,
      {
        project_id: projectId,
        id: id,
      },
      {
        requestInterceptor: applyHeaders(headers),
      }
    );
    if (payload.obj?.included)
      yield* storeIncluded({ payload: payload.obj.included });
    yield put({ type: actions.showSuccess, payload: payload.obj.data });
  } catch (e) {
    yield put({ type: actions.showFail, payload: e });
  }
}

export function* update(action) {
  const {
    project_id,
    id,
    title,
    public_description,
    secret_description,
    content_category_id,
    content_type,
    content_status,
  } = action.payload;
  let headers = yield buildHeaders();
  try {
    const SwaggerClient = yield call(apiClient);
    let payload = yield call(
      SwaggerClient.apis.UnlockBoundaries.updateUnlockBoundaryForProject,
      { project_id: project_id, id: id },
      {
        requestInterceptor: applyHeaders(headers),
        requestBody: {
          title: title,
          public_description: public_description,
          secret_description: secret_description,
          content_type: content_type,
          status: content_status,
          content_category_id: content_category_id,
        },
      }
    );

    if (payload.obj?.included)
      yield* storeIncluded({ payload: payload.obj.included });

    yield put({ type: actions.updateSuccess, payload: payload.obj.data });
  } catch (e) {
    yield put({ type: actions.updateFail, payload: e });
  }
}

/**
 * Saga Watchers
 * The exported list of sagas registered. When one of the action types is dispatched
 * the related worker saga is invoked.
 * Each saga is executed in a different thread
 */
function* unlockableBoundariesSaga() {
  yield takeEvery(actions.list, list);
  yield takeEvery(actions.show, show);
  yield takeEvery(actions.update, update);
  yield takeEvery(actions.create, create);
}
export default unlockableBoundariesSaga;
